"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getContextParent(elt) {
    var parent = elt.parentElement;
    if (!parent)
        return null;
    if (parent.dataset.phocusContextName)
        return parent;
    return getContextParent(parent);
}
// Allows elements with the same phocus-id to appear on the page, but asking to
// focus on one will always result in focusing on the one in the nearest
// ancestor context.
function focusInContext(phocusId, elt) {
    var current = elt || document.activeElement;
    var find = current.querySelector("[data-phocus-id=\"" + phocusId + "\"]");
    if (find) {
        find.focus();
    }
    else {
        var parent_1 = getContextParent(current);
        if (parent_1) {
            focusInContext(phocusId, parent_1);
        }
        else {
            console.error("No element found to focus with phocus-id " + phocusId);
        }
    }
}
exports.focusInContext = focusInContext;
//# sourceMappingURL=focus-in-context.js.map